import { render } from "./AutofillHandler.vue?vue&type=template&id=33fb4268&ts=true"
import script from "./AutofillHandler.vue?vue&type=script&lang=ts"
export * from "./AutofillHandler.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__